import { ChangeEvent, FC, memo, useRef } from 'react'
import { Button, Input, Stack, Text } from '@chakra-ui/react'
import { DownloadIcon } from '@chakra-ui/icons'

import { CloudUpload } from 'components/icons'
import UploadTakeAPicture from './components/UploadTakeAPicture'
import handleFormatFileToUploadFile from './utils/formatFileToUploadFile'
import { useUploadManager } from './contexts/UploadManager/Provider'
import { UploadProps } from '.'

const UploadContent: FC<UploadProps> = ({ isDisabled = false }) => {
  const inputRef = useRef<HTMLInputElement | null>(null)

  const { setFile } = useUploadManager()

  const handleInputClick = (): void => {
    if (inputRef.current) inputRef.current.value = ''
    inputRef.current?.click()
  }

  const handleInputOnChange = async (event: ChangeEvent<HTMLInputElement>): Promise<void> => {
    event.preventDefault()
    if (!event.target.files) return
    const file = event.target.files[0]
    if (file) {
      const uploadFile = handleFormatFileToUploadFile(file)
      setFile(uploadFile)
    }
  }

  return (
    <Stack
      bg="bgContent"
      minWidth={['200px', '250px', '300px', '350px', '350px', '350px']}
      p={4}
      rounded="md"
      borderWidth="1px"
      borderColor="borderColor"
    >
      <Input isDisabled={isDisabled} ref={inputRef} type="file" hidden onChange={handleInputOnChange} />

      <Stack width="100%" align="center" justify="center" opacity={isDisabled ? '0.4' : '1'}>
        <CloudUpload boxSize={{ base: 8, sm: 8, md: 12, lg: 12 }} />

        <Text textAlign="center" fontSize="lg">
          Clique nos botões abaixo para subir arquivo
        </Text>

        <UploadTakeAPicture isDisabled={isDisabled} />

        <Button isDisabled={isDisabled} width="100%" leftIcon={<DownloadIcon />} onClick={handleInputClick}>
          Subir arquivo
        </Button>
      </Stack>
    </Stack>
  )
}

export default memo(UploadContent)
